export default {"src":"/_next/static/media/VICI.6f3b58de.svg","height":18,"width":18};